var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c(
            "b-card-title",
            {
              staticClass: "mb-1 font-weight-bold",
              attrs: { "title-tag": "h2" }
            },
            [_c("p", [_vm._v(_vm._s(_vm.newsletterTitle))])]
          ),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end no-print" },
            [
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-primary" },
                  on: { click: _vm.getReport }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "FileTextIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("action.generate_report")))
                  ])
                ],
                1
              ),
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end pt-2 pb-1" },
            [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("total_items")) +
                    ": " +
                    _vm._s(_vm.totalSignaturesCount)
                )
              ])
            ]
          ),
          _c("b-table", {
            attrs: {
              items: _vm.signatures,
              fields: _vm.fieldsDataTable,
              striped: "",
              hover: "",
              "caption-top": "",
              responsive: "sm"
            },
            scopedSlots: _vm._u([
              {
                key: "cell(signed_at)",
                fn: function(ref) {
                  var signed_at = ref.item.signed_at
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$utils.format.date(signed_at)))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm.signatures.length === 0
            ? _c("div", { staticClass: "text-center" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.$t("newsletter.no_signatures_found")))
                ])
              ])
            : _vm._e(),
          _c("scroll-to-top")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }